import React, { type ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { ZIndex } from 'venn-ui-kit';

export interface DropdownMenuItemBaseProps {
  disabled?: boolean;
  icon?: string;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export interface DropdownMenuItemProps extends DropdownMenuItemBaseProps {
  level?: number;
  onClose?: () => void;
  children?: ReactNode;
}

export const DropdownMenuItem = (props: DropdownMenuItemProps) => {
  const { className, disabled, icon, children, level, onClick, onClose } = props;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onClick && onClick(event);
    onClose && onClose();
  };

  return (
    <button
      type="button"
      data-testid="qa-dropmenu-item-base"
      className={cn([
        'flex flex-1 items-center text-venn-grey-50 text-[12px] leading-[20px] whitespace-nowrap relative',
        `z-[${ZIndex.Front}] min-h-[25px] hover:bg-venn-grey-20 py-[4px] w-full`,
        icon ? 'px-0' : 'px-[10px]',
        disabled ? 'text-venn-grey-50 pointer-events-none' : null,
        className,
      ])}
      onClick={handleClick}
    >
      {icon && <i className={cn([icon, 'w-[9px] my-0 mx-[6px] text-venn-grey-50 text-[9px]'])} />}

      <div className={cn(['w-full inline-flex items-baseline', level ? `pl-${level * 20}px` : 'pl-0'])}>{children}</div>
    </button>
  );
};

export default DropdownMenuItem;
